import { DnaInfoCheckBoxListComponent } from './dna-info-check-box-list.component';

/**
 * 商品ＤＮＡ情報チェックボックスモデルクラス
 *
 * @export DnaInfoCheckBoxListModel
 * @class DnaInfoCheckBoxListModel
 */
export class DnaInfoCheckBoxListModel {

  /** コードリスト 表示内容および選択値を持つ */
  public codeList = [];
  /* リストインスタンス(コンポーネント) */
  public codeListUI: DnaInfoCheckBoxListComponent;
  /* コードリスト取得完了 */
  public completeUpdateCodeList: boolean = <boolean>false;
  /* 初期設定コード値 */
  public setDnaDiv: string = <string>'';
  /* 表示させないコード */
  public invalidCode: string = <string>'';

  /**
   * コンストラクタ。初期値の設定を行う
   */
  public DnaInfoCheckBoxListModel() {
  }

  /**
   * コードリストを更新する
   *
   * @param serverData コードリストのサーバ取得データ
   */
  public updateCodeList(serverData: any): void {
    // NULLチェック追加
    if (serverData == null) {
      this.codeList = [];

      return;
    }

    // コード一覧を作成
    // 表示させないコード値をリストから削除する
    let tmpList = [];
    tmpList = serverData;

    // 表示するリスト
    const tempCodeList = [];

    // 表示させないコードを取得
    let invalidCodeList = [];
    invalidCodeList = this.invalidCode.split(',');

    // ＤＮＡリストボックスを作成
    for (let i: any = 0; i < tmpList.length; i++) {
      const tempCodeListIdx: any = invalidCodeList.lastIndexOf(tmpList[i].DnaDiv);
      // 取得した項目が、表示させないコードリストになければ、ＤＮＡリストボックスに追加
      if (tempCodeListIdx === -1) {
        // チェックボックスのON/OFF保存変数を追加
        tmpList[i].selectedValue = [false];
        // 表示リストに追加
        tempCodeList.push(tmpList[i]);
      }
    }

    let index: number = <number>0;

    // コード+：+名称追加
    for (; index < tempCodeList.length; index++) {
      tempCodeList[index].DnaDivName = [tempCodeList[index].DnaDiv + ':' + tempCodeList[index].DnaName];
    }

    // 描画するリストを更新する
    this.codeList = tempCodeList;

    // 更新完了フラグをOn
    this.completeUpdateCodeList = true;

    // 描画コンポーネントに反映
    this.codeListUI.updateSelectedDnaDiv();
  }

}
